import { SectionHeading } from '@virginexperiencedays/components-v2/src/typography/SectionHeading';
import { PillStack, type PillStackProps } from '../PillStack';

import type { HTMLAttributes } from 'react';

type CategoryPillsWidgetProps = Omit<HTMLAttributes<HTMLElement>, 'onClick'> & {
  items: PillStackProps['items'];
  title?: string;
  onClick?: (data: { text: string }) => void;
};

export const CategoryPillsWidget = ({
  items,
  onClick,
  title = 'More to experience...',
  ...rest
}: CategoryPillsWidgetProps) => (
  <section {...rest}>
    <SectionHeading className="mb-4">{title}</SectionHeading>
    <PillStack items={items} onClick={onClick} />
  </section>
);
